export enum UserAvailability {
    Available = 'Available',
    Unavailable = 'Unavailable',
    Interdict = 'Interdict'
}
